import { render } from "./TermsDataTable.vue?vue&type=template&id=6ab71c0d&scoped=true"
import script from "./TermsDataTable.vue?vue&type=script&lang=js"
export * from "./TermsDataTable.vue?vue&type=script&lang=js"

import "./TermsDataTable.vue?vue&type=style&index=0&id=6ab71c0d&lang=scss&scoped=true"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab71c0d"]])

export default __exports__